<template>
  <div class="discount-banner">
    <h3 v-html="$t('discount_title')" />
    <p v-html="$t('discount_text')" />
  </div>
</template>
<script>
export default {}
</script>
